module.exports = __webpack_public_path__ + "img/00041.b488fe69.webp";